import React, { useState } from "react";
import { Formik } from "formik";
import clsx from 'clsx';

import {
    withStyles,
    Button,
    Typography,
    FormControl,
    InputLabel,
    CircularProgress,
    Paper,
    Input,
    InputAdornment,
    IconButton,

} from "@material-ui/core";

import * as Yup from "yup";
import { renderToolTip } from "../../sc-utilities/accountUtilities";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const styles = theme => ({
    root: {
        marginTop: '10%',
        margin: theme.spacing(),
        width: `30%`,
        height: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginRight: 0,
            width: '100%'
        }
    },
    submit: {
        margin: theme.spacing(),
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        borderRadius: '1px',
        marginTop: "10px"
    },
    buttons: {
        margin: theme.spacing(),
        textAlign: 'right'
    },
    formControlWithInfoField: {
        margin: theme.spacing(),
        width: "100%",
        display: 'flex',
        flexDirection: 'row'
    },
    infoTooltip: {
        margin: theme.spacing(),
        position: 'relative',
        marginTop: "38px",
        marginLeft: "15px"
    }
});


const ChangePasswordForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations, passwordComplexity } = props;

    const [value, setValue] = useState(false);

    const handleClickShowPassword = () => {
        setValue(!value);
    };

    return (
        <Paper className={classes.root}>
            <Formik
                // enableReinitialize
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, handleChange, handleBlur, handleSubmit } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <FormControl className={clsx(classes.margin, classes.formControlWithInfoField)}>
                                <InputLabel htmlFor="in-category-1">{translations['password'] || 'Password'}</InputLabel>
                                <Input
                                    id="in-category-1"
                                    type={value ? 'text' : 'password'}
                                    name="NewPassword"
                                    defaultValue={values.NewPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.NewPassword && touched.NewPassword)}
                                    fullWidth={true}
                                    margin={'dense'}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}>
                                                {value ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                                {renderToolTip(passwordComplexity, translations, classes.infoTooltip)}
                            </FormControl>

                            <FormControl className={clsx(classes.margin, classes.formControlWithInfoField)}>
                                <InputLabel htmlFor="in-category-2">{translations['password_repeat'] || 'Password repeat'}</InputLabel>
                                <Input
                                    id="in-category-2"
                                    type={value ? 'text' : 'password'}
                                    defaultValue={values.RepeatPassword}
                                    onChange={handleChange}
                                    name="RepeatPassword"
                                    onBlur={handleBlur}
                                    error={!!(errors.RepeatPassword && touched.RepeatPassword)}
                                    fullWidth={true}
                                    margin={'dense'}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                            >
                                                {value ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                                {renderToolTip(passwordComplexity, translations, classes.infoTooltip)}
                            </FormControl>
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={loading || !(isValid && dirty)}
                                    >
                                        {loading ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(ChangePasswordForm);
